import hoverintent from 'hoverintent';
import { throttle } from './throttle';


//@TODO - Accordion for mobile

const initNavigation = () => {
  const navInstances = document.querySelectorAll('.chee-nav-element');
  if (!navInstances.length) return;

  navInstances.forEach((navInstance) => {
    const $menu = navInstance.querySelector('.header-menu');
    if (!$menu) return;

    const $dropdownItems = $menu.querySelectorAll(':scope > .menu-item-has-children');
    const $toggle = document.getElementById('primary-menu-toggle');
    const $collapsible = document.getElementById('site-navigation');

    const toggleAriaOnSubmenus = ($elt = null) => {
      $dropdownItems.forEach(item => {
        const $submenu = item.querySelector('.dropdown');
        const $dropdownToggle = item.querySelector('.dropdown-toggle');
        const $btn = item.querySelector(':scope > button');
        if ($btn) {
          $btn.setAttribute('aria-expanded', 'false');
        }
        if ($dropdownToggle) {
          $dropdownToggle.setAttribute('aria-expanded', 'false');
        } else {
          item.setAttribute('aria-expanded', 'false');
        }
        if ($submenu) {
          $submenu.setAttribute('aria-hidden', 'true');
          $submenu.setAttribute('inert', '');
        }
      });
      if ($elt) {
        const $dropdownToggle = $elt.querySelector('.dropdown-toggle');
        if ($dropdownToggle) {
          $dropdownToggle.setAttribute('aria-expanded', 'true');
        } else {
          $elt.setAttribute('aria-expanded', 'true');
        }
        const $btn = $elt.querySelector(':scope > button');
        if ($btn) {
          $btn.setAttribute('aria-expanded', 'true');
        }
        const $submenu = $elt.querySelector('.dropdown');
        if ($submenu) {
          $submenu.removeAttribute('inert');
          setTimeout(() => {
            $submenu.setAttribute('aria-hidden', 'false');
          }, 1);
        }
      }
    };

    const hoverIntentOver = (e) => {
      if ($toggle && $toggle.offsetParent !== null) return;
      $dropdownItems.forEach(item => {
        if (item.contains(e.target)) {
          item.classList.add('hover');
          toggleAriaOnSubmenus(item);
        } else {
          item.classList.remove('clicked');
        }
      });
    };

    const hoverIntentOut = (e) => {
      if ($toggle && $toggle.offsetParent !== null) return;
      const closest = e.target.closest('.menu-item-has-children');
      if (closest) {
        closest.classList.remove('hover');
        if (!closest.classList.contains('clicked')) {
          const $dropdownToggle = closest.querySelector('.dropdown-toggle');
          if ($dropdownToggle) {
            $dropdownToggle.setAttribute('aria-expanded', 'false');
          } else {
            closest.setAttribute('aria-expanded', 'false');
          }
          const $btn = closest.querySelector(':scope > button');
          if ($btn) {
            $btn.setAttribute('aria-expanded', 'false');
          }
          const submenu = closest.querySelector('.dropdown');
          if (submenu) {
            submenu.setAttribute('inert', '');
            submenu.setAttribute('aria-hidden', 'true');
          }
        }
      }
    };

    const clickDropdownToggle = (e) => {
      e.preventDefault();
      e.stopPropagation();

      const $parentItem = e.target.closest('.menu-item-has-children');
      if (!$parentItem) return;

      $dropdownItems.forEach(item => {
        if (item === $parentItem) {
          const itemToShow = item.classList.contains('clicked') ? null : item;
          toggleAriaOnSubmenus(itemToShow);
          item.classList.toggle('clicked');
        } else {
          item.classList.remove('clicked');
        }
      });
    };

    const toggleCollapsible = (e, hidden = null) => {
      hidden = hidden !== null ? hidden : $collapsible.getAttribute('aria-hidden') === 'false';
      if (hidden)
        $collapsible.setAttribute('inert', '');
      else
        $collapsible.removeAttribute('inert');
      setTimeout(() => {
        if ($toggle) $toggle.setAttribute('aria-expanded', !hidden);
        $collapsible.setAttribute('aria-hidden', hidden);
      }, 1);
    };

    const closeMenus = () => {
      toggleAriaOnSubmenus();
      $dropdownItems.forEach(item => {
        item.classList.remove('hover');
        item.classList.remove('clicked');
      });
    };

    const createDropdownToggle = () => {
      const $toggle = document.createElement('button');
      $toggle.className = 'dropdown-toggle';
      $toggle.setAttribute('aria-label', 'Toggle submenu');
      $toggle.setAttribute('tabindex', '0');
      $toggle.innerHTML = '<span class="sr-only">Toggle submenu</span>';
      return $toggle;
    };

    const initDropdownItemListeners = () => {
      $dropdownItems.forEach($item => {
        $item.setAttribute('aria-haspopup', 'true');
        const $dropdownToggle = createDropdownToggle();
        const $link = $item.querySelector(':scope > a');
        const $button = $item.querySelector(':scope > button');
        if ($link) {
          $link.parentNode.insertBefore($dropdownToggle, $link.nextSibling);
        }
        if ($button) {
          $button.parentNode.insertBefore($dropdownToggle, $button.nextSibling);
        }

        $dropdownToggle.addEventListener('click', clickDropdownToggle);
        $dropdownToggle.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            clickDropdownToggle(e);
          }
        });

        if ($button) {
          $button.addEventListener('click', clickDropdownToggle);
          $button.addEventListener('focus', () => {
            if ($toggle && $toggle.offsetParent !== null) return;
            const $parentItem = $btn.closest('.menu-item-has-children');
            if ($parentItem) {
              toggleAriaOnSubmenus($parentItem);
              $parentItem.classList.add('hover');
            }
          });
        }

        hoverintent($item, hoverIntentOver, hoverIntentOut).options({
          timeout: 200,
          interval: 30,
          sensitivity: 3
        });
      });
    };

    const closeMenusIfClickOutside = (e) => {
      let clickedActualCollapsible = $collapsible && $collapsible.contains(e.target) && $collapsible !== e.target;
      if ($toggle && $toggle.offsetParent !== null && !$toggle.contains(e.target) && !clickedActualCollapsible) {
        toggleCollapsible(null, true);
      }
      if (![...$dropdownItems].some(item => item.contains(e.target))) {
        closeMenus();
      }
    };

    if ($toggle && $collapsible) {
      $toggle.addEventListener('click', toggleCollapsible);
    }
    document.addEventListener('click', closeMenusIfClickOutside);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Control' || e.key === 'Meta') return;
      closeMenusIfClickOutside(e);
    });

    let screenWidth = window.innerWidth;
    window.addEventListener('resize', throttle(() => {
      if (screenWidth === window.innerWidth) return;
      closeMenus();
      toggleCollapsible(null, $toggle && $toggle.offsetParent !== null);
      screenWidth = window.innerWidth;
    }, 50));

    if ($toggle) {
      toggleCollapsible(null, $toggle.offsetParent !== null);
    }
    initDropdownItemListeners();
    toggleAriaOnSubmenus();
  });
};

export { initNavigation };